
























import {Component, Vue} from 'vue-property-decorator';
import IconReceipt from '../assets/icon-receipt.svg';
import IconWaitlist from '../assets/icon-waitlist.svg';
import {BadgeStore, ILocalBadge} from '@/store/modules/badge.store';
import {TicketStore} from '@/store/modules/ticket.store';
import {find} from 'lodash';
import Badge from '@/components/Badge.vue';
import WaitlistOverlay from '@/components/WaitlistOverlay.vue';
import PaidBill from '@/components/PaidBill.vue';
import SingleBadge from '@/components/SingleBadge.vue';



@Component({
	components: {
		IconReceipt,
		IconWaitlist,
		badge: Badge,
		'waitlist-overlay': WaitlistOverlay,
		'paid-bill': PaidBill,
		'single-badge': SingleBadge
	}
})
export default class Home extends Vue {
	state: 'single' | 'map' = 'map';
	showOverlay = false;
	overlayColor = 'green';
	overlayMessage = '';
	showBadge = false;
	showPaidBill = false;
	// showTickets = false;
	// showWaitlist = false;
	showWaitlistOverlay = false;
	clickedBadgeId: string | null = null;
	clickedTicketId: string | null = null;
	// showDrawer = false;
	version: string = process.env.VUE_APP_VERSION;

	get placeholderBadges() {
		return Array(5).fill({}).map(() => {
			return {
				name: '​ ', // This is a special space "&#8203;"
				badgeId: Math.random() + '',
				ticketId: null,
				state: 'UNASSIGNED',
				placeholder: true
			};
		});
	}

	get badges() {
		return BadgeStore.sortedByName.map((badge) => {
			const foundTicket = TicketStore.ticketByBadgeId(badge.badgeId);
			const localBadge: ILocalBadge = {
				name: badge.name,
				badgeId: badge.badgeId,
				ticketId: null,
				state: 'UNASSIGNED',
				placeholder: false
			};
			if(foundTicket) {
				localBadge.ticketId = foundTicket.ticketId;
				localBadge.state = foundTicket.state;
			}
			return localBadge;
		});
	}



	openCounterPay() {
		this.clickedBadgeId = null;
		this.clickedTicketId = null;
		this.showBadge = true;
	}

	openWaitlistOverlay() {
		this.showWaitlistOverlay = true;
	}

	openBadge(badge: ILocalBadge) {
		this.clickedBadgeId = badge.badgeId;
		this.clickedTicketId = badge.ticketId;
		const ticket = badge.ticketId !== null ? TicketStore.byId(badge.ticketId) : null;
		if(ticket && ticket.state === 'PAID') {
			this.showPaidBill = true;
		} else {
			this.showBadge = true;
		}
	}

	openTicket(ticketId: string) {
		const ticket = TicketStore.byId(ticketId);
		if(ticket) {
			this.clickedTicketId = ticket.ticketId;
			this.clickedBadgeId = ticket.badgeId;
			if(ticket.state === 'PAID') {
				this.showPaidBill = true;
			} else {
				this.showBadge = true;
			}
		}
	}

	closeBadge(reason: string = '') {
		this.showBadge = false;
		if(reason === 'paid' && this.clickedBadgeId !== null) {
			const localBadge = find(this.badges, {badgeId: this.clickedBadgeId});
			if(localBadge) {
				this.openBadge(localBadge);
			}
		}
	}
}
